"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Stagger, StaggerItem } from "@/components/shared/motion";
import { Zap, Globe2, Phone, Wallet } from "lucide-react";

/** Four-up value props in brutalist cards. */
export default function FastValueStrip() {
  const { t } = useTranslations();
  const items = [
    { icon: Zap, title: t("cobra.value.instant.title", "Instant delivery"), desc: t("cobra.value.instant.desc", "Your QR code arrives by email right after checkout.") },
    { icon: Globe2, title: t("cobra.value.coverage.title", "180+ countries"), desc: t("cobra.value.coverage.desc", "One store for data almost anywhere you travel.") },
    { icon: Phone, title: t("cobra.value.number.title", "Keep your number"), desc: t("cobra.value.number.desc", "Your eSIM runs alongside your home SIM.") },
    { icon: Wallet, title: t("cobra.value.bills.title", "No roaming bills"), desc: t("cobra.value.bills.desc", "Pay once up front. No contracts, no surprises.") },
  ];

  return (
    <section className="container mx-auto px-4 py-12">
      <Stagger as="div" staggerChildren={0.06} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map(({ icon: Icon, title, desc }, i) => (
          <StaggerItem key={i} y={20} duration={0.35} className="border-2 border-foreground bg-card p-5 shadow-[4px_4px_0_0_hsl(var(--foreground))] transition-transform hover:-translate-x-0.5 hover:-translate-y-0.5">
            <div className="inline-flex items-center justify-center w-11 h-11 border-2 border-foreground bg-primary text-primary-foreground mb-3">
              <Icon className="w-5 h-5" />
            </div>
            <h3 className="text-lg">{title}</h3>
            <p className="mt-1 text-sm text-foreground/75 font-medium normal-case">{desc}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
